import { render, staticRenderFns } from "./BookingSearchDetailsListItem.vue?vue&type=template&id=83368674"
import script from "./BookingSearchDetailsListItem.vue?vue&type=script&lang=js"
export * from "./BookingSearchDetailsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports